/* global SentryUserData */

import {init, configureScope} from '@sentry/browser';

import {DenyURLs, IgnoreErrors, isLocalCopy, isThirdPartyEvent} from 'shared/sentry-rules';

if (process.env.NODE_ENV === 'production') {
    init({
        dsn: 'https://c791a73cda4e451f961a8df94d8b7ec7@sentry.cosmocode.de/20',
        environment: window.SentryEnvironment,
        release: window.SentryRelease,
        denyUrls: DenyURLs,
        ignoreErrors: IgnoreErrors,
        beforeSend(event) {
            if (isThirdPartyEvent(event) || isLocalCopy(event)) return null;

            return event;
        },
    });

    const user = window.SentryUserData ? {...SentryUserData} : null;

    if (user) configureScope(scope => scope.setUser(user));
}
